export default __webpack_public_path__ + "static/compareItemImg5-3ae52258e5dc3a2574e1a1745033333a.png";